import { Component } from '@angular/core';
import { LIST_PANEL_IMPORTS, ListPanelComponent } from 'src/app/panels/components/list/list-panel/list-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { PanelComponent } from '../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/list/list-panel/list-panel.component.html',
  styleUrl: '../../../../panels/components/list/list-panel/list-panel.component.scss',
  selector: 'app-building-top-10-pie-panel',
  imports: LIST_PANEL_IMPORTS,
})
export class BuildingTopPiePanelComponent extends ListPanelComponent {
  public static override readonly type = PanelType.ElectricityBuildingTopPie;
  public override title = 'Top verbruikers panden';
  public override icon = 'bi-lightning-charge-fill';
  public override unit = DisplayUnit.Kwh;
}
